export enum CoreEventTypeEnum {
  CHAIN_SERVICES = 'CHAIN_SERVICES',
  CHAIN_OBJECTS = 'CHAIN_OBJECT',
}
